import BaseComponent from "../../../../baseComponent.js";
import styles from "./styles.scss";

export default class SuffixOption extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      suffix: this.props.suffix
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({suffix: nextProps.suffix});
  }

  handleChange(event) {
    const value = event.target.value;
    this.setState({suffix: value});
    this.props.onSuffixChange(value);
  }

  render() {
    return (
      <div  style={{padding: "0 3px", width: "100px"}}>
        <input type="text" placeholder="Suffix" style={{marginBottom: "10px"}} value={this.state.suffix}
               onChange={this.handleChange}/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/textual/style/suffixOption.jsx